import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';

const SelectedResourceCard = ({ resource, onClear }) => {
  if (!resource) return null;

  const resourceId = resource.resourceKey ?? resource.id;

  return (
    <Box
      marginTop={2}
      padding={2}
      border={1}
      borderColor="primary.main"
      borderRadius={4}
      bgcolor="action.hover"
      data-testid="selected-resource-card"
    >
      <Typography variant="subtitle2" color="primary" gutterBottom>
        Selected course
      </Typography>
      <Typography variant="body1">{resource.name}</Typography>
      <Typography variant="caption" color="textSecondary">
        Course ID: {resourceId}
        {resource.description ? ` · ${resource.description}` : ''}
      </Typography>
      <Box marginTop={1}>
        <Button
          color="default"
          variant="text"
          size="small"
          onClick={onClear}
          data-testid="clear-selected-resource-btn"
        >
          Clear selection
        </Button>
      </Box>
    </Box>
  );
};

SelectedResourceCard.propTypes = {
  resource: PropTypes.object,
  onClear: PropTypes.func.isRequired,
};

SelectedResourceCard.defaultProps = {
  resource: null,
};

export default SelectedResourceCard;
